const PERSONAL_SYNC_STATUS_KEY = 'personal_sync_status';
export async function savePersonalSyncStatus(storeApi, status, _account) {
    try {
        await storeApi.put(PERSONAL_SYNC_STATUS_KEY, JSON.stringify(status), { _account });
        console.log('[contact_sync_personal_status] savePersonalSyncStatus success', { status: status.status, lastDexieWriteTime: status.lastDexieWriteTime, _account });
    }
    catch (ex) {
        console.error('[contact_sync_personal_status] savePersonalSyncStatus failed', ex);
    }
}
export async function loadPersonalSyncStatus(storeApi) {
    try {
        const result = await storeApi.get(PERSONAL_SYNC_STATUS_KEY);
        if (result.suc && result.data) {
            const parsed = JSON.parse(result.data);
            console.log('[contact_sync_personal_status] loadPersonalSyncStatus success', parsed);
            return parsed;
        }
        return null;
    }
    catch (ex) {
        console.error('[contact_sync_personal_status] loadPersonalSyncStatus failed', ex);
        return null;
    }
}
